import { render, staticRenderFns } from "./SidebarSectionConfiguration.vue?vue&type=template&id=231dde4a"
import script from "./SidebarSectionConfiguration.vue?vue&type=script&lang=js"
export * from "./SidebarSectionConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports